import { render, staticRenderFns } from "./HomeReferralRanking.vue?vue&type=template&id=7d214f6a&scoped=true&"
import script from "./HomeReferralRanking.vue?vue&type=script&lang=js&"
export * from "./HomeReferralRanking.vue?vue&type=script&lang=js&"
import style0 from "./HomeReferralRanking.vue?vue&type=style&index=0&id=7d214f6a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d214f6a",
  null
  
)

export default component.exports